var map = {
	"./arrow_down.svg": 2559,
	"./edit.svg": 7677,
	"./github.svg": 659,
	"./heart.svg": 1932,
	"./heart_on.svg": 7386,
	"./reply.svg": 4848,
	"./tip.svg": 7751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7501;